const config = {
//  baseUrl: 'http://127.0.0.1:9000',
  baseUrl:'https://adminapi.spreadsandlocks.com',
   imageUrl:'https://adminapi.spreadsandlocks.com/data/uploads' 
//  imageUrl:'http://127.0.0.1:9000/data/uploads'
};

export default config;